<template>
  <div id="dashboard-analytics">
    <div class="vx-row mt-6">
      <div class="vx-col w-full">
        <dashboard-grid />
      </div>
    </div>
  </div>
</template>

<script>
import DashboardGrid from "./pages/Dashboard/DashboardGrid";

export default {
  name: "Dashboard",
  components: {
    DashboardGrid,
  },
  data() {
    return {
      chart1Colors: ['#FEEb1A', '#FF8307', '#626262', '#1A1A1A'],
      chart1Title: this.$t('RecentUploads'),
      chart2Colors: ['#FEEb1A', '#FF8307', '#626262', '#1A1A1A'],
      chart2Title: this.$t('RecentDownloads'),

    }
  }
}
</script>

<style scoped>

</style>
